import React, { FC } from 'react';

import { PieDonutData } from '../../types';

import styles from './custom-legend.scss';

interface Props {
  pieDonutData: PieDonutData[];
}
const max_accounts = 20;

export const PieDonutCustomLegend: FC<Props> = ({ pieDonutData }) => {
  const itemsNumber = pieDonutData.length * (pieDonutData[0]?.data.length || 1);
  return (
    <div className={styles.legendContainer}>
      <div className={itemsNumber >= max_accounts ? styles.heavyLegendContent : styles.thinLegendContent}>
        {itemsNumber >= max_accounts
          ? pieDonutData.map(f => (
              <div className={styles.forecastNameContainer} key={f.forecastRef}>
                {pieDonutData.length > 1 && <b className={styles.forecast}>{f.forecastName}</b>}
                <div className={styles.labelsContainer}>
                  {f.data.map((d, li) => {
                    return (
                      <div className={styles.label} key={`${f.forecastRef}-${d.uuid}-${li}`}>
                        <span className={styles.labelColor} style={{ backgroundColor: d.color }}></span>
                        <span className={styles.labelName}>{d.name}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          : pieDonutData.map(f => (
              <div
                className={pieDonutData.length > 1 ? styles.forecastNameContainer : styles.forecastContainer}
                key={f.forecastRef}
              >
                {pieDonutData.length > 1 && <b className={styles.forecast}>{f.forecastName}</b>}
                {f.data.map((d, li) => {
                  return (
                    <div className={styles.label} key={`${f.forecastRef}-${d.uuid}-${li}`}>
                      <span className={styles.labelColor} style={{ backgroundColor: d.color }}></span>
                      <span className={styles.labelName}>{d.name}</span>
                    </div>
                  );
                })}
              </div>
            ))}
      </div>
    </div>
  );
};
